import React, { useCallback } from "react";
import {
  Route,
  Navigate,
  BrowserRouter as Router,
  Routes,
  Outlet,
} from "react-router-dom";
import SessionHelper from "./helpers/SessionHelper";
import UserPage from "./pages/users/UserPage";
import Navbar from "./components/Navbar/navbar";
import Dashboard from "./pages/Dashboard/Dashboard";
import SignIn from "./pages/SignIn/SignIn";
import EmailVerification from "./pages/EmailVerification/EmailVerification";
import { LandingPage } from "./pages/landingPage";
import LanguageHelper from "./helpers/LanguageHelper";
import { getViewAuthorizationForAll } from "./helpers/AuthorizationHelper";
import SignInHistoryPage from "./pages/History/SignIn/SignInHistoryPage";

import GdzAdmDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/gdzadm/dev/GdzAdmDevApplicationUpdatesPage";
import GdzAdmTestApplicationUpdatesPage from "./pages/applicationUpdates/projects/gdzadm/test/GdzAdmTestApplicationUpdatesPage";
import GdzProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/gdzadm/gdz/GdzProdApplicationUpdatesPage";
import AdmProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/gdzadm/adm/AdmProdApplicationUpdatesPage";

import MedasDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/medas/dev/MedasDevApplicationUpdatesPage";
import MedasTestApplicationUpdatesPage from "./pages/applicationUpdates/projects/medas/test/MedasTestApplicationUpdatesPage";
import MedasProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/medas/prod/MedasProdApplicationUpdatesPage";

import VedasDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/vedas/dev/VedasDevApplicationUpdatesPage";
import VedasProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/vedas/prod/VedasProdApplicationUpdatesPage";

import OedasDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/oedas/dev/OedasDevApplicationUpdatesPage";
import OedasProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/oedas/prod/OedasProdApplicationUpdatesPage";

import YedasDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/yedas/dev/YedasDevApplicationUpdatesPage";
import YedasProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/yedas/prod/YedasProdApplicationUpdatesPage";

import ZorenDevApplicationUpdatesPage from "./pages/applicationUpdates/projects/zoren/dev/ZorenDevApplicationUpdatesPage";
import ZorenProdApplicationUpdatesPage from "./pages/applicationUpdates/projects/zoren/prod/ZorenProdApplicationUpdatesPage";

import ISGHUBApplicationUpdatesPage from "./pages/applicationUpdates/projects/isghub/prod/ISGHUBApplicationUpdatesPage";

import ISGDEMOApplicationUpdatesPage from "./pages/applicationUpdates/projects/isgdemo/prod/ISGDEMOApplicationUpdatesPage";

import DOCUMENTATIONHUBApplicationUpdatesPage from "./pages/applicationUpdates/projects/documentationhub/prod/DOCUMENTATIONHUBApplicationUpdatesPage";

import IdealKontratApplicationUpdatesPage from "./pages/applicationUpdates/projects/idealkontrat/prod/IdealKontratApplicationUpdatesPage";

import PINCIDENTPUBLICApplicationUpdatesPage from "./pages/applicationUpdates/projects/pincidentpublic/prod/PINCIDENTPUBLICApplicationUpdatesPage";

import TicketPage from "./pages/tickets/TicketPage";
import OsgbIzlemePage from "./pages/osgbIzleme/OsgbIzlemePage";

const auth = [
  {
    path: "/SignIn",
    component: SignIn,
    exact: false,
  },
  {
    path: "/verification",
    component: EmailVerification,
    exact: false,
  },
];

const publicRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/users",
    component: UserPage,
  },
  {
    path: "/sign-in-history",
    component: SignInHistoryPage,
  },
  {
    path: "/gdzadm-dev/application-updates",
    component: GdzAdmDevApplicationUpdatesPage,
  },
  {
    path: "/gdzadm-test/application-updates",
    component: GdzAdmTestApplicationUpdatesPage,
  },
  {
    path: "/gdz-prod/application-updates",
    component: GdzProdApplicationUpdatesPage,
  },
  {
    path: "/adm-prod/application-updates",
    component: AdmProdApplicationUpdatesPage,
  },
  {
    path: "/medas-dev/application-updates",
    component: MedasDevApplicationUpdatesPage,
  },
  {
    path: "/medas-test/application-updates",
    component: MedasTestApplicationUpdatesPage,
  },
  {
    path: "/medas-prod/application-updates",
    component: MedasProdApplicationUpdatesPage,
  },
  {
    path: "/vedas-dev/application-updates",
    component: VedasDevApplicationUpdatesPage,
  },
  {
    path: "/vedas-prod/application-updates",
    component: VedasProdApplicationUpdatesPage,
  },
  {
    path: "/oedas-dev/application-updates",
    component: OedasDevApplicationUpdatesPage,
  },
  {
    path: "/oedas-prod/application-updates",
    component: OedasProdApplicationUpdatesPage,
  },
  ,
  {
    path: "/yedas-dev/application-updates",
    component: YedasDevApplicationUpdatesPage,
  },
  {
    path: "/yedas-prod/application-updates",
    component: YedasProdApplicationUpdatesPage,
  },
  ,
  {
    path: "/zoren-dev/application-updates",
    component: ZorenDevApplicationUpdatesPage,
  },
  {
    path: "/zoren-prod/application-updates",
    component: ZorenProdApplicationUpdatesPage,
  },
  {
    path: "/isghub/application-updates",
    component: ISGHUBApplicationUpdatesPage,
  },
  {
    path: "/isgdemo/application-updates",
    component: ISGDEMOApplicationUpdatesPage,
  },
  {
    path: "/documentationhub/application-updates",
    component: DOCUMENTATIONHUBApplicationUpdatesPage,
  },
  {
    path: "/idealkontrat/application-updates",
    component: IdealKontratApplicationUpdatesPage,
  },
  {
    path: "/pincidentpublic/application-updates",
    component: PINCIDENTPUBLICApplicationUpdatesPage,
  },
  {
    path: "/tickets",
    component: TicketPage,
  },
  {
    path: "/osgb-izleme/isg-professionals",
    component: OsgbIzlemePage,
  },
];

class Label {
  constructor(condition, label, path = null) {
    this.label = label;
    this.path = path;
    this.condition = condition;
    this.values = [];
  }

  addSubLabel(subLabel) {
    if (!(subLabel instanceof Label)) {
      throw new Error("Sub-label must be an instance of Label");
    }

    // Push the sub-label into `values`
    this.values.push(subLabel);

    // Update the condition with logical OR
    this.condition = this.condition || subLabel.condition;
  }

  toDrawerItem() {
    if (!this.condition) return null;

    const base = {
      label: this.label,
    };

    if (this.path) {
      base.Path = this.path;
    }

    if (this.values.length > 0) {
      base.values = this.values
        .map((sub) => sub.toDrawerItem())
        .filter(Boolean); // remove null sub-labels
    }

    return base;
  }
}

function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = SessionHelper.getIsLoggedIn();
  return isLoggedIn ? <Outlet /> : <Navigate to="/signin" />;
}

export default function AppRoutes() {
  const language = LanguageHelper.getLanguage();
  const user = SessionHelper.getUser();

  const [drawerList, setDrawerList] = React.useState([]);
  const [update, setUpdate] = React.useState(false);

  const populateDrawerList = useCallback(() => {
    if (user) {
      const lib = language.sidebar;
      const permissions = user.permissions;
      const auth = getViewAuthorizationForAll(permissions);

      const dashboard = new Label(true, lib.dashboard, "/dashboard");

      //region ISGHUB
      const isghubAppUpdate = new Label(
        auth.isghubAppUpdate,
        lib.application_updates,
        "/isghub/application-updates",
      );

      const isghub = new Label(false, lib.isghub);
      isghub.addSubLabel(isghubAppUpdate);
      //endregion

      // region PINCIDENT PUBLIC
      const pincidentPublicAppUpdate = new Label(
        auth.pincidentPublicAppUpdate,
        lib.application_updates,
        "/pincidentpublic/application-updates",
      );

      const pincidentPublic = new Label(false, lib.pincident_public);
      pincidentPublic.addSubLabel(pincidentPublicAppUpdate);
      //endregion

      // region DOCUMENTATION HUB
      const documentationHubAppUpdate = new Label(
        auth.documentationHubAppUpdate,
        lib.application_updates,
        "/documentationhub/application-updates",
      );

      const documentationHub = new Label(false, lib.documentation_hub);
      documentationHub.addSubLabel(documentationHubAppUpdate);
      //endregion

      //region ISGDEMO
      const isgdemoAppUpdate = new Label(
        auth.isgdemoAppUpdate,
        lib.application_updates,
        "/isgdemo/application-updates",
      );

      const isgdemo = new Label(false, lib.isgdemo);
      isgdemo.addSubLabel(isgdemoAppUpdate);
      //endregion

      //region GDZ ADM
      const gdzadmDevAppUpdate = new Label(
        auth.gdzadmDevAppUpdate,
        lib.application_updates,
        "/gdzadm-dev/application-updates",
      );
      const gdzadmTestAppUpdate = new Label(
        auth.gdzadmTestAppUpdate,
        lib.application_updates,
        "/gdzadm-test/application-updates",
      );
      const gdzProdAppUpdate = new Label(
        auth.gdzProdAppUpdate,
        lib.application_updates,
        "/gdz-prod/application-updates",
      );
      const admProdAppUpdate = new Label(
        auth.admProdAppUpdate,
        lib.application_updates,
        "/adm-prod/application-updates",
      );

      const gdzAdmDev = new Label(false, lib.gdzadm_dev);
      gdzAdmDev.addSubLabel(gdzadmDevAppUpdate);

      const gdzAdmTest = new Label(false, lib.gdzadm_test);
      gdzAdmTest.addSubLabel(gdzadmTestAppUpdate);

      const gdzProd = new Label(false, lib.gdz_prod);
      gdzProd.addSubLabel(gdzProdAppUpdate);

      const admProd = new Label(false, lib.adm_prod);
      admProd.addSubLabel(admProdAppUpdate);

      const gdzAdm = new Label(false, lib.gdz_adm);
      gdzAdm.addSubLabel(gdzAdmDev);
      gdzAdm.addSubLabel(gdzAdmTest);
      gdzAdm.addSubLabel(gdzProd);
      gdzAdm.addSubLabel(admProd);
      //endregion

      //region MEDAS
      const medasDevAppUpdate = new Label(
        auth.medasDevAppUpdate,
        lib.application_updates,
        "/medas-dev/application-updates",
      );
      const medasTestAppUpdate = new Label(
        auth.medasTestAppUpdate,
        lib.application_updates,
        "/medas-test/application-updates",
      );
      const medasProdAppUpdate = new Label(
        auth.medasProdAppUpdate,
        lib.application_updates,
        "/medas-prod/application-updates",
      );

      const medasDev = new Label(false, lib.medas_dev);
      medasDev.addSubLabel(medasDevAppUpdate);

      const medasTest = new Label(false, lib.medas_test);
      medasTest.addSubLabel(medasTestAppUpdate);

      const medasProd = new Label(false, lib.medas_prod);
      medasProd.addSubLabel(medasProdAppUpdate);

      const medas = new Label(false, lib.medas);
      medas.addSubLabel(medasDev);
      medas.addSubLabel(medasTest);
      medas.addSubLabel(medasProd);
      //endregion

      //region VEDAS
      const vedasDevAppUpdate = new Label(
        auth.vedasDevAppUpdate,
        lib.application_updates,
        "/vedas-dev/application-updates",
      );
      const vedasProdAppUpdate = new Label(
        auth.vedasProdAppUpdate,
        lib.application_updates,
        "/vedas-prod/application-updates",
      );

      const vedasDev = new Label(false, lib.vedas_dev);
      vedasDev.addSubLabel(vedasDevAppUpdate);

      const vedasProd = new Label(false, lib.vedas_prod);
      vedasProd.addSubLabel(vedasProdAppUpdate);

      const vedas = new Label(false, lib.vedas);
      vedas.addSubLabel(vedasDev);
      vedas.addSubLabel(vedasProd);
      //endregion

      //region OEDAS
      const oedasDevAppUpdate = new Label(
        auth.oedasDevAppUpdate,
        lib.application_updates,
        "/oedas-dev/application-updates",
      );
      const oedasProdAppUpdate = new Label(
        auth.oedasProdAppUpdate,
        lib.application_updates,
        "/oedas-prod/application-updates",
      );

      const oedasDev = new Label(false, lib.oedas_dev);
      oedasDev.addSubLabel(oedasDevAppUpdate);

      const oedasProd = new Label(false, lib.oedas_prod);
      oedasProd.addSubLabel(oedasProdAppUpdate);

      const oedas = new Label(false, lib.oedas);
      oedas.addSubLabel(oedasDev);
      oedas.addSubLabel(oedasProd);
      //endregion

      //region YEDAS
      const yedasDevAppUpdate = new Label(
        auth.yedasDevAppUpdate,
        lib.application_updates,
        "/yedas-dev/application-updates",
      );
      const yedasProdAppUpdate = new Label(
        auth.yedasProdAppUpdate,
        lib.application_updates,
        "/yedas-prod/application-updates",
      );

      const yedasDev = new Label(false, lib.yedas_dev);
      yedasDev.addSubLabel(yedasDevAppUpdate);

      const yedasProd = new Label(false, lib.yedas_prod);
      yedasProd.addSubLabel(yedasProdAppUpdate);

      const yedas = new Label(false, lib.yedas);
      yedas.addSubLabel(yedasDev);
      yedas.addSubLabel(yedasProd);
      //endregion

      //region ZOREN
      const zorenDevAppUpdate = new Label(
        auth.zorenDevAppUpdate,
        lib.application_updates,
        "/zoren-dev/application-updates",
      );
      // const zorenProdAppUpdate = new Label(
      //   auth.zorenProdAppUpdate,
      //   lib.application_updates,
      //   "/zoren-prod/application-updates",
      // );

      const zorenDev = new Label(false, lib.zoren_dev);
      zorenDev.addSubLabel(zorenDevAppUpdate);

      // const zorenProd = new Label(false, lib.zoren_prod);
      // zorenProd.addSubLabel(zorenProdAppUpdate);

      const zoren = new Label(false, lib.zoren);
      zoren.addSubLabel(zorenDev);
      // zoren.addSubLabel(zorenProd);
      //endregion

      //region IDEAL KONTRAT
      const idealKontratAppUpdate = new Label(
        auth.idealKontratAppUpdate,
        lib.application_updates,
        "/idealkontrat/application-updates",
      );

      const idealKontrat = new Label(false, lib.ideal_kontrat);
      idealKontrat.addSubLabel(idealKontratAppUpdate);
      //endregion

      //region Management
      const usersTable = new Label(auth.usersTable, lib.users, "/users");
      const signInHistory = new Label(
        auth.signInHistory,
        language.history.signIn,
        "/sign-in-history",
      );

      const management = new Label(false, lib.management);
      management.addSubLabel(usersTable);
      management.addSubLabel(signInHistory);
      //endregion

      //region Tickets
      const tickets = new Label(auth.tickets, "Destek Talepleri", "/tickets");
      const osgbIzlemeIsgProfessionals = new Label(
        auth.osgbIzlemeIsgProfessionals,
        "OSGB İzleme Servisi Kullanıcıları",
        "/osgb-izleme/isg-professionals",
      );

      const drawerList = [
        dashboard,
        isghub,
        pincidentPublic,
        documentationHub,
        isgdemo,
        gdzAdm,
        medas,
        vedas,
        oedas,
        yedas,
        zoren,
        idealKontrat,
        tickets,
        osgbIzlemeIsgProfessionals,
        management,
      ]
        .map((label) => label.toDrawerItem())
        .filter(Boolean);

      console.log("drawerList", drawerList);
      setDrawerList(drawerList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, user, update]);

  const init = useCallback(() => {
    populateDrawerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [populateDrawerList, update]);
  React.useEffect(() => {
    init();
  }, [init, user]);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" exact element={<LandingPage />}></Route>
          {auth.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              element={
                <route.component update={update} setUpdate={setUpdate} />
              }
            ></Route>
          ))}
          <Route path="/" element={<PrivateRoute />}>
            {publicRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                element={
                  <Navbar
                    component={<route.component />}
                    drawerList={drawerList}
                  />
                }
              ></Route>
            ))}
          </Route>
        </Routes>
      </Router>
    </>
  );
}
